import {
  IGetRowsParams,
  IServerSideDatasource,
  IServerSideGetRowsParams,
} from 'ag-grid-community';

import { IAssemblyOrderFilterParams } from '../interfaces/assembly-order.interface';

export class AssemblyOrderUtil {
  static mapRequestFilters(
    params :IServerSideGetRowsParams | IGetRowsParams,
  ) :IAssemblyOrderFilterParams {
    const filters :IAssemblyOrderFilterParams = {};
    const filterModel = 'request' in params ? params.request.filterModel : params;

    if (!filterModel) {
      return filters;
    }

    if (filterModel.id) {
      filters.orderId = filterModel.id.filter.toString();
    }

    if (filterModel.internalSku) {
      filters.internalSku = filterModel.internalSku.filter;
    }

    if (filterModel['rfq.internalSku']) {
      filters.internalSku = filterModel['rfq.internalSku'].filter;
    }

    if (filterModel['rfq.productName']) {
      filters.productName = filterModel['rfq.productName'].filter;
    }

    if (filterModel.productName) {
      filters.productName = filterModel.productName.filter;
    }

    if (filterModel.age) {
      filters.age = filterModel.age.filter.toString();

      if (filterModel.age.filterTo) {
        filters.age += `,${filterModel.age.filterTo.toString()}`;
      }
    }

    if (filterModel.startTime) {
      filters.startTime = filterModel.startTime.dateFrom.split(' ')[0];
    }

    if (filterModel.endTime) {
      filters.endTime = filterModel.endTime.dateFrom.split(' ')[0];
    }

    if (filterModel.status) {
      filters.orderStatus = filterModel.status.values
        .join(',')
        .replace(' ', '_')
        .toLowerCase();
    }

    if (filterModel.plannedQuantity) {
      filters.plannedQuantityRange = filterModel.plannedQuantity.filter.toString();

      if (filterModel.plannedQuantity.filterTo) {
        filters.plannedQuantityRange += `,${filterModel.plannedQuantity.filterTo.toString()}`;
      }
    }

    if (filterModel.actualQuantity) {
      filters.plannedQuantityRange = filterModel.actualQuantity.filter.toString();

      if (filterModel.actualQuantity.filterTo) {
        filters.plannedQuantityRange += `,${filterModel.actualQuantity.filterTo.toString()}`;
      }
    }

    if (filterModel.type) {
      filters.type = filterModel.type.values
        .join(',')
        .replace(' ', '_')
        .toLowerCase();
    }

    if (filterModel.alternateIds) {
      filters.alternateId = filterModel.alternateIds.filter;
    }

    return filters;
  }

  static mapRequestParams(
    params :IServerSideGetRowsParams | IGetRowsParams,
    defaultParams ?:{ [param :string] :string | string[] },
  ) :{
    [param :string] :string | string[];
  } {
    const filters = AssemblyOrderUtil.mapRequestFilters(params);
    const relations = 'rfq,plannedUom,actualUom,extraCosts,alternateIds';

    return {
      relations,
      ...defaultParams,
      ...filters,
    };
  }
}
